import React, { Fragment, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { Typography } from '@mui/material';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { useDispatch, useSelector } from 'react-redux'
import { v4 as uuidv4 } from 'uuid';
import { DataGrid} from '@mui/x-data-grid';
import { entregasParciales } from '../../../redux/DuckPanelHologramas/ModuloInventarioDuck';
import ModalEntregasParcialesComponent from './ModalEntregasParcialesComponent';

const ModalHistorialEntregasComponent = (props) => {

    const dispatch = useDispatch()
    const historial = useSelector(store => store.ModuloInventario.historialEntregas)

    const [openModalEntregas, setOpenModalEntregas] = React.useState(true);
    const [openModalEntregasParciales, setOpenModalEntregasParciales] = React.useState(false)
    
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 880,
        height: 700,
        bgcolor: '#E3EFF1',
        border: 'px solid #000',
        boxShadow: 24,
        p: 4,
        color: 'black'
    };

    const columns = [
        { field: 'tipoSolicitud', headerName: 'Tipo solicitud', headerAlign: 'center', flex: 1 },
        { field: 'fechaSolicitud', headerName: 'Fecha solicitud', headerAlign: 'center', flex: 1 },
        { field: 'hologramasSolicitados', headerName: 'Hologramas solicitados', headerAlign: 'center', flex: 1.5 },
        { field: 'entregas', headerName: 'Entregas', headerAlign: 'center', flex: 1,
            renderCell: (params) =>                 
                <button className={`btn btn-outline-success`} style={{marginRight: '10px'}} onClick={() => EntregasParciales(params)}>Entregas realizadas</button>                           
        }
    ]

    const rows = []
    historial?.map(anexo => {

        let solicitud = ''
        let fechaSolicitud = ''
        if (anexo?.tiposolicitud == 'FC_09') {
            solicitud = 'Exportación'
            fechaSolicitud = anexo?.fc_09_solicitudemicioncertificadonomexportacionyentregahologram?.fechasolicitud.substring(0, 10)
        }else if (anexo?.tiposolicitud == 'FC_33') {
            solicitud = 'Nacional'
            fechaSolicitud = anexo?.fc_33_solicitudenvasadonacional?.fechasolicitud.substring(0, 10)
        }else if (anexo?.tiposolicitud == 'FC_41') {
            solicitud = 'Bebida con mezcal'
            fechaSolicitud = anexo?.fc_41_solicitudparabebidasconmezcal?.fechasolicitud.substring(0, 10)
        }
        rows.push({
            id: uuidv4(), tipoSolicitud: solicitud, fechaSolicitud: fechaSolicitud,
            hologramasSolicitados: anexo?.entregashologramas?.[0]?.hologramassolcitados,
            idInformacionEntrega: anexo?.idinformacionentrega
        })
        console.log('fecha solicitud: ', fechaSolicitud)
    })  

    const handleCloseModal = () => {
        setOpenModalEntregas(false)
        props.setOpenModalEntregas.setOpenModalEntregas()
    }

    const EntregasParciales = async (params) => {
        await dispatch(entregasParciales(params.row.idInformacionEntrega))
        setOpenModalEntregasParciales(true)
    }

    const modalComponent = () => {
        return (
            <div>
                <Modal
                    open={openModalEntregas}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Typography id="modal-modal-title" className='text-danger' style={{ color: "white" }}> 
                            <center ><h3 style={{ color: "#0D717C", fontFamily: "Montserrat", fontWeight: "bold" }}>Historial de entrega de hologramas</h3></center>
                        </Typography>
                        <Typography id="modal-modal-description" component="h2" style={{ color: "black", textAlign: 'justify' }}>
                            <Box sx={{ height: 525, width: '100%', mt: 2 }}>
                                <DataGrid
                                    rows={rows}
                                    columns={columns}
                                    disableColumnMenu={true}
                                    pageSize={8}
                                    sx={{
                                        boxShadow: 0,
                                        color: 'black',
                                        border: 0,
                                        backgroundColor: 'white',
                                        '& .MuiDataGrid-cell': {
                                            display: 'block',
                                            position: 'relative',
                                            textAlign: 'center',
                                        },
                                        '& .MuiDataGrid-columnHeaders': {
                                            backgroundColor: '#4399A4',
                                            color: 'white',
                                            fontFamily: 'Montserrat',
                                            fontWeight: 'bold',
                                            height: '20px'
                                        }
                                    }}
                                />
                            </Box>
                        </Typography>
                        <Typography sx={{ mt: 2, textAlign: 'center' }}>
                            <button className={`btn btn-outline-success`} style={{width: '70%'}} onClick={() => handleCloseModal()}>Aceptar</button>
                        </Typography>
                    </Box>
                </Modal>

                { openModalEntregasParciales &&
                    <ModalEntregasParcialesComponent setOpenModalEntregasParciales={{ setOpenModalEntregasParciales }} ></ModalEntregasParcialesComponent>
                }
            </div>
        )
    }

    return (
        <Fragment>
            {modalComponent()}
        </Fragment>
    )
};

export default withRouter(ModalHistorialEntregasComponent)
